import { render, staticRenderFns } from "./HubspotNotification.vue?vue&type=template&id=897fe858"
import script from "./HubspotNotification.vue?vue&type=script&lang=js"
export * from "./HubspotNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports